import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import {AuthService} from "../../services/auth-service.service";
import {Roles} from "../../role-based.guard";

const misc: any = {
  sidebar_mini_active: true
};

export interface RouteInfo {
  path: string;
  title: string;
  type: string;
  icontype: string;
  collapse?: string;
  isCollapsed?: boolean;
  isCollapsing?: any;
  children?: ChildrenItems[];
  roles?: string[];
}

export interface ChildrenItems {
  path: string;
  title: string;
  type?: string;
  collapse?: string;
  children?: ChildrenItems2[];
  isCollapsed?: boolean;
}
export interface ChildrenItems2 {
  path?: string;
  title?: string;
  type?: string;
}
//Menu Items
export const ROUTES: RouteInfo[] = [
  {
    path: "/organization",
    title: "My Organization",
    type: "link",
    icontype: "custom-icon-organization",
    isCollapsed: false,
    roles: [Roles.INTERNAL]
  },
  {
    path: "/external-contact",
    title: "External Contact",
    type: "link",
    icontype: "custom-icon-organization",
    isCollapsed: false,
    roles: [Roles.EXTERNAL]
  },
  {
    path: "/funding-opportunities",
    title: "Funding opportunities",
    type: "link",
    icontype: "custom-icon-project",
    isCollapsed: false,
    roles: [Roles.INTERNAL]
  },
  {
    path: "/external-active-assignment",
    title: "Active assignment",
    type: "link",
    icontype: "custom-icon-project",
    isCollapsed: false,
    roles: [Roles.EXTERNAL]
  },
  {
    path: "/applications",
    title: "My applications",
    type: "link",
    icontype: "custom-icon-applications",
    isCollapsed: false,
    roles: [Roles.INTERNAL]
  },

  {
    path: "/documentlibrary",
    title: "General Documents",
    type: "link",
    icontype: "custom-icon-doc",
    isCollapsed: false,
    roles: [Roles.INTERNAL]
  },{
    path: "/FAQ",
    title: "FAQ",
    type: "link",
    icontype: "custom-icon-faq",
    isCollapsed: false,
    roles: [Roles.INTERNAL]
  },
];

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.scss"]
})
export class SidebarComponent implements OnInit {
  public menuItems: any[] | undefined;
  public isCollapsed = true;
  private userRole: string[] | undefined;

  constructor(private router: Router,private authService: AuthService
  ) {}

  ngOnInit() {
    this.userRole = this.authService.getUserRole();
    this.menuItems = ROUTES.filter(menuItem => menuItem.roles?.some(role => this.userRole!.includes(role)));

    this.router.events.subscribe(_ => {
      this.isCollapsed = true;
    });
  }
  onMouseEnterSidenav() {
    if (!document.body.classList.contains("g-sidenav-pinned")) {
      document.body.classList.add("g-sidenav-show");
    }
  }
  onMouseLeaveSidenav() {
    if (!document.body.classList.contains("g-sidenav-pinned")) {
      document.body.classList.remove("g-sidenav-show");
    }
  }
  minimizeSidebar() {
    const sidenavToggler = document.getElementsByClassName(
      "sidenav-toggler"
    )[0];
    const body = document.getElementsByTagName("body")[0];
    if (body.classList.contains("g-sidenav-pinned")) {
      misc.sidebar_mini_active = true;
    } else {
      misc.sidebar_mini_active = false;
    }
    if (misc.sidebar_mini_active === true) {
      body.classList.remove("g-sidenav-pinned");
      body.classList.add("g-sidenav-hidden");
      sidenavToggler.classList.remove("active");
      misc.sidebar_mini_active = false;
    } else {
      body.classList.add("g-sidenav-pinned");
      body.classList.remove("g-sidenav-hidden");
      sidenavToggler.classList.add("active");
      misc.sidebar_mini_active = true;
    }
  }
}
